export default __webpack_public_path__ + "static/f01a5e92a5da34b757eb5c425905c65a.jpeg";